import * as React from 'react';
export const tdSvg = React.forwardRef(function tdSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#00B624',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M14.34 23.35V12.11h2.5v8.65h3.32c2.14 0 3.32-.42 3.32-4.33 0-3.93-1.98-5.19-4.15-5.19h-6.66v12.11h-2.5v-12.1H5.2v-2.6H21c3.85 0 5.82 2.67 5.82 7.78 0 6.73-2.96 6.92-6.65 6.92',
      }),
    ),
  );
});
tdSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var td = {
  category: 'brand',
  colorable: false,
  name: 'td',
  svg: tdSvg,
};
